<script setup lang="ts">
import { usePageConnectorStore } from '@apps/main/new-desktop/core/stores/pageConnectorStore';

import { TransportType } from '@libs/trip-planner-interfaces';

import type { UnavailableItineraryFlightSegment } from '../../../models';
import { useTripOverviewPageStore } from '../../../stores';
import ItineraryTimeline from '../ItineraryTimeline.vue';
import ItineraryTransportSelector from '../ItineraryTransportSelector.vue';

import UnavailableFlightProduct from './UnavailableFlightProduct.vue';
import FlightSegmentHeader from './FlightSegmentHeader.vue';

interface UnavailableFlightSegmentProps {
  segment: UnavailableItineraryFlightSegment;
}

const props = defineProps<UnavailableFlightSegmentProps>();

interface UnavailableFlightSegmentEmits {
  (eventName: 'remove-filter', id: string): void;
  (eventName: 'show-more-filters'): void;
}

const emit = defineEmits<UnavailableFlightSegmentEmits>();

const pageConnectorStore = usePageConnectorStore();
const tripOverviewPageStore = useTripOverviewPageStore();
</script>

<template>
  <ItineraryTimeline :segment-type="props.segment.segmentType">
    <template #dropdown>
      <ItineraryTransportSelector
        :transport-type="TransportType.Flight"
        :disabled="false"
        @select-transport="
          tripOverviewPageStore.selectTransport(segment, $event)
        "
      />
    </template>
    <template #header>
      <FlightSegmentHeader
        :segment="props.segment"
        :print-mode="false"
        @show-more-filters="emit('show-more-filters')"
        @remove-filter="emit('remove-filter', $event)"
      />
    </template>

    <template #content>
      <UnavailableFlightProduct
        :reasons="props.segment.reasons"
        :message="
          tripOverviewPageStore.getUnavailabilityMessage(
            props.segment.segmentType,
            props.segment.reasons
          )
        "
        @edit-filters="pageConnectorStore.openFlightListFilters()"
        @try-another-date="tripOverviewPageStore.scrollToCalendar()"
      />
    </template>
  </ItineraryTimeline>
</template>
